import { FC, useState } from "react";
import ReactDOM from "react-dom";
import styles from "./modal.module.scss";
import { modalProps } from "./modal.type";
import { Typography } from "top-brains-ui";
import Button from "../button/Button";
import { BTN_COLORS } from "@src/styles/ColorConstants";
import { X } from "lucide-react";

const Modal: FC<modalProps> = ({
  customHeader,
  body = <>Your Content</>,
  customFooter,
  headerTitle,
  primaryButtonText = "Save",
  secondaryButtonText = "Cancel",
  closeOnOutsideClick = false,
  showPrimaryButton = true,
  showSecondaryButton = true,
  showCloseButton = true,
  showHeader = true,
  showFooter = true,
  height = "300px",
  width = "500px",
  maxHeight,
  isOpen = true,
  onClose = () => {},
  onPrimaryButtonClick = () => {},
  onSecondaryButtonClick = () => {},
  variant = "default",
  disablePrimaryButton = false,
  closeOnPrimaryClick = true,
  zIndex = 9999,
}) => {
  const [open, setOpen] = useState<boolean>(isOpen || true);

  const handleClose = () => {
    onClose?.();
    setOpen(false);
  };

  const handlePrimarybuttonClick = () => {
    if (closeOnPrimaryClick) {
      handleClose();
    }

    onPrimaryButtonClick?.();
  };

  const handleSecondaryButtonClick = () => {
    handleClose();
    onSecondaryButtonClick?.();
  };

  return ReactDOM.createPortal(
    <div
      className={`${styles.modalContainer} ${
        variant === "website" ? styles.websiteVariant : ""
      }`}
      style={{ display: open ? "flex" : "none", zIndex: zIndex }}
      onClick={() => {
        if (closeOnOutsideClick) handleClose();
      }}
    >
      <div
        className={styles.modalBody}
        style={{
          height,
          width,
          maxHeight,
          paddingBottom: showFooter ? undefined : "0",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {showHeader && (
          <div className={styles.modalHeader}>
            {customHeader ? (
              customHeader
            ) : (
              <div className={styles.headerContent}>
                <Typography fontWeight="medium" fontSize={"14px"}>
                  {headerTitle ? headerTitle : ""}
                </Typography>
                {showCloseButton && (
                  <X
                    strokeWidth={2.5}
                    size={20}
                    color="#B2B2B2"
                    className={styles.closeButton}
                    onClick={handleClose}
                    cursor={"pointer"}
                  />
                )}
              </div>
            )}
          </div>
        )}

        <div
          className={styles.modalContent}
          style={{
            height: showFooter ? undefined : "calc(100% - 48px)",
            flexGrow: showFooter ? undefined : 1,
          }}
        >
          {body}
        </div>

        {showFooter && (
          <div className={styles.modalFooter}>
            {customFooter ? (
              customFooter
            ) : (
              <div className={styles.footerContent}>
                {showSecondaryButton && (
                  <Button
                    variant="secondary"
                    size="medium"
                    onClick={handleSecondaryButtonClick}
                  >
                    {secondaryButtonText}
                  </Button>
                )}
                {showPrimaryButton && (
                  <Button
                    variant="primary"
                    size="medium"
                    style={{ color: BTN_COLORS.BTN_TEXT_COLOR }}
                    onClick={handlePrimarybuttonClick}
                    disabled={disablePrimaryButton}
                  >
                    {primaryButtonText}
                  </Button>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
